import { render } from "./BreadcrumbBlog.vue?vue&type=template&id=4ae9e430&scoped=true"
import script from "./BreadcrumbBlog.vue?vue&type=script&lang=js"
export * from "./BreadcrumbBlog.vue?vue&type=script&lang=js"

import "./BreadcrumbBlog.vue?vue&type=style&index=0&id=4ae9e430&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae9e430"]])

export default __exports__